<template>
  <b-tab>
    <template v-slot:title>
      <i class="fas fa-user-times"></i> Rejected Users
    </template>
    <b-container fluid>
      <b-card class="border-0">
        <template v-if="rejectedUsers.length == 0">
          <h4 class="disclaimerText">
            No Data Available in Rejected Users Table!
          </h4>
        </template>
        <template v-else>
          <b-card>
            <b-row class="w-100 m-0">
              <b-col lg="12" class="p-0">
                <b-col sm="5" md="5" lg="4" class="mt-2 pr-2 float-right">
                  <b-form-group
                    label="Search"
                    label-for="filter-input"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Type to Search"
                      ></b-form-input>

                      <!-- <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append> -->
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-col>
            </b-row>
            <b-row class="w-100 m-0">
              <b-table
                class="mt-2 w-100"
                id="pending_user_table"
                :items="rejectedUsers"
                :fields="fields"
                sort-icon-right
                responsive="sm"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                striped
                @filtered="onFiltered"
              >
                <!-- <template #cell(user_id)="row">
                  <b-link
                    href="#"
                    @click="
                      editUserDetails(row.item.user_id, row.index, $event.target)
                    "
                    class="mr-1"
                  >
                    <i
                      class="fas fa-edit actionIcon font-size-16"
                      title="Edit User Access"
                    ></i>
                  </b-link>
                  <b-link href="#" @click="deleteUser(row.item.user_id)">
                    <i
                      class="fas fa-times-circle actionIcon font-size-16"
                      tilte="Delete User"
                    ></i>
                  </b-link>
                </template> -->
              </b-table>
            </b-row>
            <b-row>
              <b-col sm="7" md="12" class="mb-3">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-card>
    </b-container>
  </b-tab>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "RejectedUsers",
  computed: {
    ...mapGetters(["rejectedUsers"]),
  },
  methods: {
    // ...mapActions(["getEditedUserAccessDetails"]),
    // editUserDetails(id) {
    //   this.getEditedUserAccessDetails(id);
    // },
    // deleteUser(id) {
    //   console.log("delete user id:", id);
    // },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  data() {
    return {
      fields: [
        { key: "username", sortable: true },
        { key: "email", sortable: true },
        { key: "phone_number", sortable: true },
        { key: "mobile_number", sortable: true },
        { key: "role", sortable: true },
        // { key: "id", label: "Manage Access" },
      ],
      perPage: 5,
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterOn: [],
    };
  },
  mounted() {
    this.totalRows = this.rejectedUsers.length;
  },
};
</script>

<style>
.table thead th {
  text-align: left !important;
}
</style>
